<template>
  <div class="announcement">
    <img src="../assets/icons/home/announcement@2x.png" class="logo" alt="" />
    <div class="line"></div>
    <div class="text-container">
      <div class="text-bar" :style="`left: ${distance}px`">
        <p ref="scrollText">{{ currentContent }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Announcement",
  props: {
    announcements: {
      type: Array,
      default: () => []
    },
    intervalTime: {
      type: Number,
      default: 20
    },
    stopTime: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    currentContent() {
      if (this.announcements.length > 0) {
        return this.announcements[this.currentIndex].content;
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      distance: 350,
      moving: true
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      const textWidth = this.$refs["scrollText"].offsetWidth;
      if (this.moving) {
        this.distance--;
      }
      if (-this.distance > textWidth) {
        this.distance = 350;
        this.switchShow();
      }
      if (this.distance === 0 && this.moving) {
        this.moving = false;
        setTimeout(() => {
          this.moving = true;
        }, this.stopTime);
      }
    }, this.intervalTime);
  },
  methods: {
    switchShow() {
      const length = this.announcements.length;
      let index = ++this.currentIndex;
      if (index === length) {
        index = 0;
      }
      this.currentIndex = index;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.announcement {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 50px;
  background: rgba(255, 244, 247, 1);
  border-radius: 25px;
  text-align: left;
  .logo {
    margin-left: 15px;
    width: 37px;
    height: 16px;
  }
  .line {
    margin: 0 12px;
    width: 1px;
    height: 18px;
    background: rgba(230, 224, 224, 1);
  }
  .text-container {
    position: relative;
    flex: 1;
    overflow: hidden;
    .text-bar {
      position: relative;
      display: flex;
      p {
        white-space: nowrap;
      }
    }
  }
}
</style>
